import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type";
import { getDisplayedAirlineCode } from "@/utils/flight/getDisplayedAirlineCode";
import { isFlightCountable } from "./filtersFlights/filterFlights";
import { byAirline } from "./filtersFlights/byAirline";
import { byClass } from "./filtersFlights/byClass";
import { byPrice } from "./filtersFlights/byPrice";
import { byRangeTime } from "./filtersFlights/byRangeTime";
import { byStops } from "./filtersFlights/byStops";

type CountFacet = "stops" | "airlines" | "classes"

const matchesOtherFilters = (state: FlightState, flight: TypeFlight, excludedFacet: CountFacet) => {
  const fare = state.flightsResult.fares[flight.fareDataId]

  return (
    (excludedFacet === "stops" || byStops(state, flight)) &&
    byPrice(state, flight) &&
    (excludedFacet === "classes" || byClass(state, flight)) &&
    byRangeTime(state, flight) &&
    (excludedFacet === "airlines" || byAirline(state, flight, fare))
  )
}

export const calcCountFlights = (state: FlightState) => {
  const initCount = {
    stops: {
      direct: 0,
      one_stop: 0,
      multi_stop: 0
    },
    classes: {
      economy: 0,
      business: 0,
      first_class: 0
    },
    airlines: {} as Record<string, number>
  }

  for (let i = 0; i < state.flightsResult.layout.flightIds.length; i++) {
    const flightId = state.flightsResult.layout.flightIds[i];
    const flight = state.flightsResult.flights[flightId]
    if (!flight || !isFlightCountable(state, flight)) continue

    const fare = state.flightsResult.fares[flight.fareDataId]
    const airlineCode = getDisplayedAirlineCode(state, flight, fare)
    if (airlineCode && matchesOtherFilters(state, flight, "airlines")) {
      initCount.airlines[airlineCode] = (initCount.airlines[airlineCode] || 0) + 1
    }

    if (matchesOtherFilters(state, flight, "stops")) {
      if (flight.stopNumber === 0) {
        initCount.stops.direct++
      }

      if (flight.stopNumber === 1) {
        initCount.stops.one_stop++
      }

      if (flight.stopNumber > 1) {
        initCount.stops.multi_stop++
      }
    }

    if (matchesOtherFilters(state, flight, "classes")) {
      const cabinClasses = new Set(flight.inventories.map(inventory => inventory.cabinClassType))
      if (cabinClasses.has('Economy')) {
        initCount.classes.economy++
      }

      if (cabinClasses.has('First class')) {
        initCount.classes.first_class++
      }

      if (cabinClasses.has('Business')) {
        initCount.classes.business++
      }
    }
  }

  state.flightsResult.count = initCount
}